/** the clock reads 10:00 AM when the game starts */
export const GAME_START_HOUR_OF_DAY = 10;
/** minutes after game start when the grid drops (noon) */
export const OUTAGE_START_MINUTE = 120;
/** minutes after game start when the grid is restored (noon the next day) */
export const RESTORE_MINUTE = 1560;

/** real seconds per game hour at 1x speed (~2:10 total play time) */
export const SECONDS_PER_GAME_HOUR = 5;

export const INDOOR_START_F = 70;
export const HVAC_TARGET_F = 70;
/** how fast HVAC pushes indoor temp toward target, °F per game hour */
export const HVAC_DEGREES_PER_HOUR = 5;
/** smart thermostat: HVAC only draws power once the house drifts this far from target */
export const HVAC_DEADBAND_F = 1;

export const COMFORT_BAND_F = { max: 78, min: 62 };
export const EXTREME_BAND_F = { max: 86, min: 50 };

export const MOOD_START = 80;
export const MOOD_MAX = 100;
/** mood lost per game hour outside the comfort band */
export const MOOD_DRIFT_UNCOMFORTABLE = 2;
/** mood lost per game hour outside the extreme band */
export const MOOD_DRIFT_EXTREME = 5;
/** mood lost per game hour while the battery is dead during the outage */
export const MOOD_DRIFT_BLACKOUT = 4;

/** eu/hr the grid charges the battery while power is up */
export const GRID_CHARGE_EU_PER_HOUR = 2;
/** stored eu required for the house to come back from a dead battery */
export const BATTERY_RESTART_EU = 0.5;

/** lights only draw power while it's dark out */
export const DARK_HOURS = { from: 18, until: 7 };

/** nobody texts complaints while the household sleeps */
export const ASLEEP_HOURS = { from: 22, until: 7 };

/** the fridge keeps food cold for a while after losing power */
export const FRIDGE_GRACE_MINUTES = 180;
/** total unpowered fridge minutes before the food is lost for good */
export const FOOD_SPOILS_AT_MINUTES = 360;
export const SPOILAGE_MOOD_HIT = 10;
/** mood lost per game hour while food is at risk (fridge off past its grace) */
export const MOOD_DRIFT_FOOD_RISK = 3;
/** mood lost per game hour while the Wi-Fi is off — the teen suffers loudly */
export const MOOD_DRIFT_NO_WIFI = 2;
/** unpowered Wi-Fi minutes before Riley notices */
export const WIFI_GRUMBLE_AT_MINUTES = 45;
